const WEB3_LOCAL_INSTANCE = "http://localhost:7545";
const WEB3_FANTOM_INSTANCE = "wss://wsapi.fantom.network";

const FANTOM_ID = 250;

const FANTOM_NETWORK = {
  method: "wallet_addEthereumChain",
  params: [
    {
      chainId: `0x${FANTOM_ID.toString(16)}`,
      chainName: "Fantom Opera",
      nativeCurrency: {
        name: "FTM",
        symbol: "ftm",
        decimals: 18,
      },
      rpcUrls: ["https://rpc.ftm.tools"],
      blockExplorerUrls: [`https://ftmscan.com`],
    },
  ],
};

const RARITY_BASE_MAX_SCORE = 32;

const RARITY_SUMMONERS = (accountId) =>
  `https://api.ftmscan.com/api?module=account&action=tokennfttx&contractaddress=0xce761D788DF608BD21bdd59d6f4B54b2e27F25Bb&address=${accountId}&apikey=81CTWCS4N63GKQ4FUZ2YMC85M98YGUNTCN`;

const CODEX_ABI_FEATS_1 = [
  {
    inputs: [],
    name: "acrobatic",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "agile",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "alertness",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "animal_affinity",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "armor_proficiency_heavy",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "armor_proficiency_light",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "armor_proficiency_medium",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "athletic",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "augment_summoning",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "blind_fight",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "brew_potion",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "class",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "cleave",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "combat_casting",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "combat_expertise",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "combat_reflexes",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "craft_magic_arms_and_armor",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "craft_rod",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "craft_staff",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "craft_wand",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "craft_wondrous_item",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "deceitful",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "deflect_arrows",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "deft_hands",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "diehard",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "diligent",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "dodge",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "empower_spell",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "endurance",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "enlarge_spell",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "eschew_materials",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "exotic_weapon_proficiency",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "extend_spell",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "extra_turning",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "far_shot",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_id", type: "uint256" }],
    name: "feat_by_id",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "forge_ring",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "great_cleave",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "great_fortitude",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "greater_spell_focus",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "greater_spell_peneratrion",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "greater_two_weapon_fighting",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "greater_weapon_focus",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "greater_weapon_specialization",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "heighten_spell",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "improved_bull_rush",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "improved_counterspell",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "improved_critical",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "improved_disarm",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "improved_feint",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "improved_grapple",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "improved_initiative",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "improved_overrun",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "improved_precise_shot",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "improved_shield_bash",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "improved_two_weapon_fighting",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "improved_unarmed_strike",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "index",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "point_blank_shot",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "power_attack",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "precise_shot",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "shield_proficiency",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "spell_focus",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "spell_penetration",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "two_weapon_fighting",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "weapon_focus",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "weapon_specialization",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
];
const CODEX_ABI_FEATS_2 = [
  {
    inputs: [],
    name: "class",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_id", type: "uint256" }],
    name: "feat_by_id",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "improved_sunder",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "improved_trip",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "improved_turning",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "index",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "investigator",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "iron_will",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "lightning_reflexes",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "magical_aptitude",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "manyshot",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "martial_weapon_proficiency",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "maximize_spell",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "mobility",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "mounted_archery",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "mounted_combat",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "negotiator",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "nimble_fingers",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "persuasive",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "quick_draw",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "quicken_spell",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "rapid_reload",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "rapid_shot",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "ride_by_attack",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "run",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "scribe_scroll",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "self_sufficient",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "silent_spell",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "simple_weapon_proficiency",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "spell_penetration",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "stealthy",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "still_spell",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "toughness",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "tower_shield_proficiency",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "two_weapon_defense",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "weapon_finesse",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "widen_spell",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
];
const RARITY_ABI_FEATS = [
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "character_created",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_id", type: "uint256" }],
    name: "feat_by_id",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "bool", name: "prerequisites", type: "bool" },
      { internalType: "uint256", name: "prerequisites_feat", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_class", type: "uint256" },
      { internalType: "uint256", name: "prerequisites_level", type: "uint256" },
      { internalType: "string", name: "benefit", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "", type: "uint256" },
      { internalType: "uint256", name: "", type: "uint256" },
    ],
    name: "feats",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "", type: "uint256" },
      { internalType: "uint256", name: "", type: "uint256" },
    ],
    name: "feats_by_id",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "_class", type: "uint256" },
      { internalType: "uint256", name: "_level", type: "uint256" },
    ],
    name: "feats_per_class",
    outputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_level", type: "uint256" }],
    name: "feats_per_level",
    outputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_class", type: "uint256" }],
    name: "get_base_class_feats",
    outputs: [{ internalType: "uint8[7]", name: "_feats", type: "uint8[7]" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_summoner", type: "uint256" }],
    name: "get_feats",
    outputs: [{ internalType: "bool[100]", name: "_feats", type: "bool[100]" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_summoner", type: "uint256" }],
    name: "get_feats_by_id",
    outputs: [{ internalType: "uint256[]", name: "_feats", type: "uint256[]" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_summoner", type: "uint256" }],
    name: "get_feats_by_name",
    outputs: [{ internalType: "string[]", name: "_names", type: "string[]" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "feat", type: "uint256" }],
    name: "is_valid",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "_flag", type: "uint256" },
      { internalType: "uint256", name: "_class", type: "uint256" },
    ],
    name: "is_valid_class",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "_summoner", type: "uint256" },
      { internalType: "uint256", name: "_feat", type: "uint256" },
    ],
    name: "select_feat",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_summoner", type: "uint256" }],
    name: "setup_class",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const CODEX_ADDRESS_FEATS_1 = "0x88db734E9f64cA71a24d8e75986D964FFf7a1E10";
const CODEX_ADDRESS_FEATS_2 = "0x7A4Ba2B077CD9f4B13D5853411EcAE12FADab89C";
const RARITY_ADDRESS_FEATS = "0x4F51ee975c01b0D6B29754657d7b3cC182f20d8a";

const CODEX_ABI_SKILLS = [
  {
    inputs: [],
    name: "appraise",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "balance",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "bluff",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "class",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "climb",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "concentration",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "craft",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "decipher_script",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "diplomacy",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "disable_device",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "disguise",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "escape_artist",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "forgery",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "gather_information",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "id", type: "uint256" }],
    name: "get_attribute",
    outputs: [{ internalType: "string", name: "attribute", type: "string" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "handle_animal",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "heal",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "hide",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "index",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "intimidate",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "jump",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "knowledge",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "listen",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "move_silently",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "open_lock",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "perform",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "profession",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "ride",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "search",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "sense_motive",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_id", type: "uint256" }],
    name: "skill_by_id",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "sleight_of_hand",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "speak_language",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "spellcraft",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "spot",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "survival",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "swim",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "tumble",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "use_magic_device",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "use_rope",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "uint256", name: "attribute_id", type: "uint256" },
      { internalType: "uint256", name: "synergy", type: "uint256" },
      { internalType: "bool", name: "retry", type: "bool" },
      { internalType: "bool", name: "armor_check_penalty", type: "bool" },
      { internalType: "string", name: "check", type: "string" },
      { internalType: "string", name: "action", type: "string" },
    ],
    stateMutability: "pure",
    type: "function",
  },
];
const CODEX_ADDRESS_SKILLS = "0x67ae39a2Ee91D7258a86CD901B17527e19E493B3";

const RARITY_ABI_SKILLS = [
  {
    inputs: [{ internalType: "uint256", name: "_class", type: "uint256" }],
    name: "base_per_class",
    outputs: [{ internalType: "uint256", name: "base", type: "uint256" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "_class", type: "uint256" },
      { internalType: "uint8[36]", name: "_skills", type: "uint8[36]" },
    ],
    name: "calculate_points_for_set",
    outputs: [{ internalType: "uint256", name: "points", type: "uint256" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_class", type: "uint256" }],
    name: "class_skills",
    outputs: [{ internalType: "bool[36]", name: "_skills", type: "bool[36]" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_class", type: "uint256" }],
    name: "class_skills_by_name",
    outputs: [{ internalType: "string[]", name: "", type: "string[]" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_summoner", type: "uint256" }],
    name: "get_skills",
    outputs: [{ internalType: "uint8[36]", name: "", type: "uint8[36]" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "_summoner", type: "uint256" },
      { internalType: "uint8[36]", name: "_skills", type: "uint8[36]" },
    ],
    name: "is_valid_set",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_attribute", type: "uint256" }],
    name: "modifier_for_attribute",
    outputs: [{ internalType: "int256", name: "_modifier", type: "int256" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "_summoner", type: "uint256" },
      { internalType: "uint8[36]", name: "_skills", type: "uint8[36]" },
    ],
    name: "set_skills",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "", type: "uint256" },
      { internalType: "uint256", name: "", type: "uint256" },
    ],
    name: "skills",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "int256", name: "_int", type: "int256" },
      { internalType: "uint256", name: "_class", type: "uint256" },
      { internalType: "uint256", name: "_level", type: "uint256" },
    ],
    name: "skills_per_level",
    outputs: [{ internalType: "uint256", name: "points", type: "uint256" }],
    stateMutability: "pure",
    type: "function",
  },
];
const RARITY_ADDRESS_SKILLS = "0x51C0B29A1d84611373BA301706c6B4b72283C80F";

const RARITY_ABI = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      { indexed: false, internalType: "bool", name: "approved", type: "bool" },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "from", type: "address" },
      { indexed: true, internalType: "address", name: "to", type: "address" },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "summoner",
        type: "uint256",
      },
    ],
    name: "leveled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "class",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "summoner",
        type: "uint256",
      },
    ],
    name: "summoned",
    type: "event",
  },
  {
    inputs: [{ internalType: "uint256", name: "_summoner", type: "uint256" }],
    name: "adventure",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "adventurers_log",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "owner", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "class",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "id", type: "uint256" }],
    name: "classes",
    outputs: [{ internalType: "string", name: "description", type: "string" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "getApproved",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "operator", type: "address" },
    ],
    name: "isApprovedForAll",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "level",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_summoner", type: "uint256" }],
    name: "level_up",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "next_summoner",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "ownerOf",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" },
      { internalType: "bytes", name: "_data", type: "bytes" },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "operator", type: "address" },
      { internalType: "bool", name: "approved", type: "bool" },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "_summoner", type: "uint256" },
      { internalType: "uint256", name: "_xp", type: "uint256" },
    ],
    name: "spend_xp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_class", type: "uint256" }],
    name: "summon",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_summoner", type: "uint256" }],
    name: "summoner",
    outputs: [
      { internalType: "uint256", name: "_xp", type: "uint256" },
      { internalType: "uint256", name: "_log", type: "uint256" },
      { internalType: "uint256", name: "_class", type: "uint256" },
      { internalType: "uint256", name: "_level", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_summoner", type: "uint256" }],
    name: "tokenURI",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "xp",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "curent_level", type: "uint256" },
    ],
    name: "xp_required",
    outputs: [
      { internalType: "uint256", name: "xp_to_next_level", type: "uint256" },
    ],
    stateMutability: "pure",
    type: "function",
  },
];
const RARITY_ADDRESS = "0xce761d788df608bd21bdd59d6f4b54b2e27f25bb";

const RARITY_ABI_ATTRIBUTES = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "summoner",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "strength",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "dexterity",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "constitution",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "intelligence",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "wisdom",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "charisma",
        type: "uint32",
      },
    ],
    name: "Created",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "leveler",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "summoner",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "strength",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "dexterity",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "constitution",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "intelligence",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "wisdom",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "charisma",
        type: "uint32",
      },
    ],
    name: "Leveled",
    type: "event",
  },
  {
    inputs: [
      { internalType: "uint256", name: "current_level", type: "uint256" },
    ],
    name: "abilities_by_level",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "ability_scores",
    outputs: [
      { internalType: "uint32", name: "strength", type: "uint32" },
      { internalType: "uint32", name: "dexterity", type: "uint32" },
      { internalType: "uint32", name: "constitution", type: "uint32" },
      { internalType: "uint32", name: "intelligence", type: "uint32" },
      { internalType: "uint32", name: "wisdom", type: "uint32" },
      { internalType: "uint32", name: "charisma", type: "uint32" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "score", type: "uint256" }],
    name: "calc",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "_str", type: "uint256" },
      { internalType: "uint256", name: "_dex", type: "uint256" },
      { internalType: "uint256", name: "_const", type: "uint256" },
      { internalType: "uint256", name: "_int", type: "uint256" },
      { internalType: "uint256", name: "_wis", type: "uint256" },
      { internalType: "uint256", name: "_cha", type: "uint256" },
    ],
    name: "calculate_point_buy",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "character_created",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_summoner", type: "uint256" }],
    name: "increase_charisma",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_summoner", type: "uint256" }],
    name: "increase_constitution",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_summoner", type: "uint256" }],
    name: "increase_dexterity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_summoner", type: "uint256" }],
    name: "increase_intelligence",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_summoner", type: "uint256" }],
    name: "increase_strength",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_summoner", type: "uint256" }],
    name: "increase_wisdom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "level_points_spent",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "_summoner", type: "uint256" },
      { internalType: "uint32", name: "_str", type: "uint32" },
      { internalType: "uint32", name: "_dex", type: "uint32" },
      { internalType: "uint32", name: "_const", type: "uint32" },
      { internalType: "uint32", name: "_int", type: "uint32" },
      { internalType: "uint32", name: "_wis", type: "uint32" },
      { internalType: "uint32", name: "_cha", type: "uint32" },
    ],
    name: "point_buy",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_summoner", type: "uint256" }],
    name: "tokenURI",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
];
const RARITY_ADDRESS_ATTRIBUTES = "0xb5f5af1087a8da62a23b08c00c6ec9af21f397a1";

const RARITY_ABI_NAMES = [
  {
    inputs: [],
    name: "cost",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_summoner", type: "uint256" }],
    name: "full_name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "n",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "_summoner", type: "uint256" },
      { internalType: "string", name: "_name", type: "string" },
    ],
    name: "set_name",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_summoner", type: "uint256" }],
    name: "summoner_name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_lvl", type: "uint256" }],
    name: "title",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "pure",
    type: "function",
  },
];
const RARITY_ADDRESS_NAMES = "0x4c40ce3fb33a6781c903bc830804de4195cc966f";
const RARITY_ABI_DUNGEONS = [
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "uint256", name: "from", type: "uint256" },
      { indexed: true, internalType: "uint256", name: "to", type: "uint256" },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "uint256", name: "from", type: "uint256" },
      { indexed: true, internalType: "uint256", name: "to", type: "uint256" },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [{ internalType: "uint256", name: "_summoner", type: "uint256" }],
    name: "adventure",
    outputs: [{ internalType: "uint256", name: "reward", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "adventurers_log",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "", type: "uint256" },
      { internalType: "uint256", name: "", type: "uint256" },
    ],
    name: "allowance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "from", type: "uint256" },
      { internalType: "uint256", name: "spender", type: "uint256" },
      { internalType: "uint256", name: "amount", type: "uint256" },
    ],
    name: "approve",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_dex", type: "uint256" }],
    name: "armor_class",
    outputs: [{ internalType: "int256", name: "", type: "int256" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "_class", type: "uint256" },
      { internalType: "uint256", name: "_str", type: "uint256" },
      { internalType: "uint256", name: "_level", type: "uint256" },
    ],
    name: "attack_bonus",
    outputs: [{ internalType: "int256", name: "", type: "int256" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_class", type: "uint256" }],
    name: "base_attack_bonus_by_class",
    outputs: [{ internalType: "uint256", name: "attack", type: "uint256" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "_class", type: "uint256" },
      { internalType: "uint256", name: "_level", type: "uint256" },
    ],
    name: "base_attack_bonus_by_class_and_level",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_str", type: "uint256" }],
    name: "damage",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "dungeon_armor_class",
    outputs: [{ internalType: "int256", name: "", type: "int256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "dungeon_damage",
    outputs: [{ internalType: "int256", name: "", type: "int256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "dungeon_health",
    outputs: [{ internalType: "int256", name: "", type: "int256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "dungeon_to_hit",
    outputs: [{ internalType: "int256", name: "", type: "int256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_class", type: "uint256" }],
    name: "health_by_class",
    outputs: [{ internalType: "uint256", name: "health", type: "uint256" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "_class", type: "uint256" },
      { internalType: "uint256", name: "_level", type: "uint256" },
      { internalType: "uint32", name: "_const", type: "uint32" },
    ],
    name: "health_by_class_and_level",
    outputs: [{ internalType: "uint256", name: "health", type: "uint256" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_attribute", type: "uint256" }],
    name: "modifier_for_attribute",
    outputs: [{ internalType: "int256", name: "_modifier", type: "int256" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_summoner", type: "uint256" }],
    name: "scout",
    outputs: [{ internalType: "uint256", name: "reward", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "int256", name: "_attack_bonus", type: "int256" }],
    name: "to_hit_ac",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "from", type: "uint256" },
      { internalType: "uint256", name: "to", type: "uint256" },
      { internalType: "uint256", name: "amount", type: "uint256" },
    ],
    name: "transfer",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "executor", type: "uint256" },
      { internalType: "uint256", name: "from", type: "uint256" },
      { internalType: "uint256", name: "to", type: "uint256" },
      { internalType: "uint256", name: "amount", type: "uint256" },
    ],
    name: "transferFrom",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const RARITY_ABI_GOLD = [
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "uint256", name: "from", type: "uint256" },
      { indexed: true, internalType: "uint256", name: "to", type: "uint256" },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "uint256", name: "from", type: "uint256" },
      { indexed: true, internalType: "uint256", name: "to", type: "uint256" },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      { internalType: "uint256", name: "", type: "uint256" },
      { internalType: "uint256", name: "", type: "uint256" },
    ],
    name: "allowance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "from", type: "uint256" },
      { internalType: "uint256", name: "spender", type: "uint256" },
      { internalType: "uint256", name: "amount", type: "uint256" },
    ],
    name: "approve",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "summoner", type: "uint256" }],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "summoner", type: "uint256" }],
    name: "claimable",
    outputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "claimed",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "from", type: "uint256" },
      { internalType: "uint256", name: "to", type: "uint256" },
      { internalType: "uint256", name: "amount", type: "uint256" },
    ],
    name: "transfer",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "executor", type: "uint256" },
      { internalType: "uint256", name: "from", type: "uint256" },
      { internalType: "uint256", name: "to", type: "uint256" },
      { internalType: "uint256", name: "amount", type: "uint256" },
    ],
    name: "transferFrom",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "level", type: "uint256" }],
    name: "wealth_by_level",
    outputs: [{ internalType: "uint256", name: "wealth", type: "uint256" }],
    stateMutability: "pure",
    type: "function",
  },
];
const RARITY_ADDRESS_GOLD = "0x2069B76Afe6b734Fb65D1d099E7ec64ee9CC76B2";
const RARITY_ADDRESS_DUNGEONS = "0x2A0F1cB17680161cF255348dDFDeE94ea8Ca196A";

const RARITY_ABI_FOREST = [
  {
    inputs: [{ internalType: "address", name: "_rarityAddr", type: "address" }],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      { indexed: false, internalType: "bool", name: "approved", type: "bool" },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "summonerId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "ResearchStarted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "from", type: "address" },
      { indexed: true, internalType: "address", name: "to", type: "address" },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "treasureId",
        type: "uint256",
      },
    ],
    name: "TreasureDiscovered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "treasureId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "summonerId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newLevel",
        type: "uint256",
      },
    ],
    name: "TreasureLevelUp",
    type: "event",
  },
  {
    inputs: [],
    name: "_tokenIdCounter",
    outputs: [{ internalType: "uint256", name: "_value", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "owner", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "summonerId", type: "uint256" }],
    name: "discover",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "getApproved",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "operator", type: "address" },
    ],
    name: "isApprovedForAll",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "summonerId", type: "uint256" },
      { internalType: "uint256", name: "tokenId", type: "uint256" },
    ],
    name: "levelUp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "ownerOf",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "rarityContract",
    outputs: [{ internalType: "contract IRarity", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" },
      { internalType: "bytes", name: "_data", type: "bytes" },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "operator", type: "address" },
      { internalType: "bool", name: "approved", type: "bool" },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "summonerId", type: "uint256" },
      { internalType: "uint256", name: "timeInDays", type: "uint256" },
    ],
    name: "startResearch",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes4", name: "interfaceId", type: "bytes4" }],
    name: "supportsInterface",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "tokenURI",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "treasure",
    outputs: [
      { internalType: "string", name: "_itemName", type: "string" },
      { internalType: "uint256", name: "_magic", type: "uint256" },
      { internalType: "uint256", name: "_level", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "currentLevel", type: "uint256" },
    ],
    name: "xpRequired",
    outputs: [
      { internalType: "uint256", name: "xpToNextLevel", type: "uint256" },
    ],
    stateMutability: "pure",
    type: "function",
  },
];
const RARITY_ADDRESS_FOREST = "0xb37d3d79ea86B0334d9322c695339D577A3D57be";

const RARITY_ABI_DAYCARE = [
  {
    inputs: [{ internalType: "uint256[]", name: "_ids", type: "uint256[]" }],
    name: "adventureTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const RARITY_ADDRESS_DAYCARE = "0x0D4C98901563ca730332e841EDBCB801fe9F2551";

const RARITY_CRAFT = {
  BASE: {
    ADDRESS: "0xf41270836dF4Db1D28F7fd0935270e3A603e78cC",
    ABI: [
      { inputs: [], stateMutability: "nonpayable", type: "constructor" },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: "address",
            name: "owner",
            type: "address",
          },
          {
            indexed: true,
            internalType: "address",
            name: "approved",
            type: "address",
          },
          {
            indexed: true,
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
        ],
        name: "Approval",
        type: "event",
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: "address",
            name: "owner",
            type: "address",
          },
          {
            indexed: true,
            internalType: "address",
            name: "operator",
            type: "address",
          },
          {
            indexed: false,
            internalType: "bool",
            name: "approved",
            type: "bool",
          },
        ],
        name: "ApprovalForAll",
        type: "event",
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: "address",
            name: "owner",
            type: "address",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "check",
            type: "uint256",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "summoner",
            type: "uint256",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "base_type",
            type: "uint256",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "item_type",
            type: "uint256",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "gold",
            type: "uint256",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "craft_i",
            type: "uint256",
          },
        ],
        name: "Crafted",
        type: "event",
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: "address",
            name: "from",
            type: "address",
          },
          {
            indexed: true,
            internalType: "address",
            name: "to",
            type: "address",
          },
          {
            indexed: true,
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
        ],
        name: "Transfer",
        type: "event",
      },
      {
        inputs: [],
        name: "SUMMMONER_ID",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "to", type: "address" },
          { internalType: "uint256", name: "tokenId", type: "uint256" },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [{ internalType: "address", name: "owner", type: "address" }],
        name: "balanceOf",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "uint256", name: "_summoner", type: "uint256" },
          { internalType: "uint8", name: "_base_type", type: "uint8" },
          { internalType: "uint8", name: "_item_type", type: "uint8" },
          {
            internalType: "uint256",
            name: "_crafting_materials",
            type: "uint256",
          },
        ],
        name: "craft",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [
          { internalType: "uint256", name: "_summoner", type: "uint256" },
          { internalType: "uint256", name: "_dc", type: "uint256" },
        ],
        name: "craft_skillcheck",
        outputs: [
          { internalType: "bool", name: "crafted", type: "bool" },
          { internalType: "int256", name: "check", type: "int256" },
        ],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
        name: "getApproved",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "uint256", name: "_item_id", type: "uint256" },
        ],
        name: "get_armor_dc",
        outputs: [{ internalType: "uint256", name: "dc", type: "uint256" }],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [
          { internalType: "uint256", name: "_base_type", type: "uint256" },
          { internalType: "uint256", name: "_item_id", type: "uint256" },
        ],
        name: "get_dc",
        outputs: [{ internalType: "uint256", name: "dc", type: "uint256" }],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "get_goods_dc",
        outputs: [{ internalType: "uint256", name: "dc", type: "uint256" }],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [
          { internalType: "uint256", name: "_base_type", type: "uint256" },
          { internalType: "uint256", name: "_item_type", type: "uint256" },
        ],
        name: "get_item_cost",
        outputs: [{ internalType: "uint256", name: "cost", type: "uint256" }],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [{ internalType: "uint256", name: "_item", type: "uint256" }],
        name: "get_token_uri_armor",
        outputs: [{ internalType: "string", name: "output", type: "string" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [{ internalType: "uint256", name: "_item", type: "uint256" }],
        name: "get_token_uri_goods",
        outputs: [{ internalType: "string", name: "output", type: "string" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [{ internalType: "uint256", name: "_item", type: "uint256" }],
        name: "get_token_uri_weapon",
        outputs: [{ internalType: "string", name: "output", type: "string" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "uint256", name: "_type_id", type: "uint256" },
        ],
        name: "get_type",
        outputs: [{ internalType: "string", name: "_type", type: "string" }],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [
          { internalType: "uint256", name: "_item_id", type: "uint256" },
        ],
        name: "get_weapon_dc",
        outputs: [{ internalType: "uint256", name: "dc", type: "uint256" }],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "owner", type: "address" },
          { internalType: "address", name: "operator", type: "address" },
        ],
        name: "isApprovedForAll",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "uint256", name: "_base_type", type: "uint256" },
          { internalType: "uint256", name: "_item_type", type: "uint256" },
        ],
        name: "isValid",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        name: "items",
        outputs: [
          { internalType: "uint8", name: "base_type", type: "uint8" },
          { internalType: "uint8", name: "item_type", type: "uint8" },
          { internalType: "uint32", name: "crafted", type: "uint32" },
          { internalType: "uint256", name: "crafter", type: "uint256" },
        ],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "uint256", name: "_attribute", type: "uint256" },
        ],
        name: "modifier_for_attribute",
        outputs: [
          { internalType: "int256", name: "_modifier", type: "int256" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "name",
        outputs: [{ internalType: "string", name: "", type: "string" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "next_item",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
        name: "ownerOf",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "from", type: "address" },
          { internalType: "address", name: "to", type: "address" },
          { internalType: "uint256", name: "tokenId", type: "uint256" },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "from", type: "address" },
          { internalType: "address", name: "to", type: "address" },
          { internalType: "uint256", name: "tokenId", type: "uint256" },
          { internalType: "bytes", name: "_data", type: "bytes" },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "operator", type: "address" },
          { internalType: "bool", name: "approved", type: "bool" },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [
          { internalType: "uint256", name: "_summoner", type: "uint256" },
          { internalType: "uint256", name: "_base_type", type: "uint256" },
          { internalType: "uint256", name: "_item_type", type: "uint256" },
          {
            internalType: "uint256",
            name: "_crafting_materials",
            type: "uint256",
          },
        ],
        name: "simulate",
        outputs: [
          { internalType: "bool", name: "crafted", type: "bool" },
          { internalType: "int256", name: "check", type: "int256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "dc", type: "uint256" },
        ],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "bytes4", name: "interfaceId", type: "bytes4" },
        ],
        name: "supportsInterface",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "symbol",
        outputs: [{ internalType: "string", name: "", type: "string" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [{ internalType: "uint256", name: "index", type: "uint256" }],
        name: "tokenByIndex",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "owner", type: "address" },
          { internalType: "uint256", name: "index", type: "uint256" },
        ],
        name: "tokenOfOwnerByIndex",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [{ internalType: "uint256", name: "_item", type: "uint256" }],
        name: "tokenURI",
        outputs: [{ internalType: "string", name: "uri", type: "string" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "totalSupply",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "from", type: "address" },
          { internalType: "address", name: "to", type: "address" },
          { internalType: "uint256", name: "tokenId", type: "uint256" },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
    ],
  },
  GOODS: {
    ADDRESS: "0x0C5C1CC0A7AE65FE372fbb08FF16578De4b980f3",
    ABI: [
      {
        inputs: [],
        name: "caltrops",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "candle",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "chain",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "class",
        outputs: [{ internalType: "string", name: "", type: "string" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "crowbar",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "flint_and_steel",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "grappling_hook",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "hammer",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "index",
        outputs: [{ internalType: "string", name: "", type: "string" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "ink",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [{ internalType: "uint256", name: "_id", type: "uint256" }],
        name: "item_by_id",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "jug_clay",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "lamp_common",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "lantern_bullseye",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "lantern_hooded",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "lock_amazing",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "lock_average",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "lock_good",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "lock_very_simple",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "manacles",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "manacles_masterwork",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "oil",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "rope_hempen",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "rope_silk",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "spyglass",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "torch",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "vial",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
    ],
  },
  ARMOUR: {
    ADDRESS: "0xf5114A952Aca3e9055a52a87938efefc8BB7878C",
    ABI: [
      {
        inputs: [],
        name: "banded_mail",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "proficiency", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "uint256", name: "armor_bonus", type: "uint256" },
          { internalType: "uint256", name: "max_dex_bonus", type: "uint256" },
          { internalType: "int256", name: "penalty", type: "int256" },
          { internalType: "uint256", name: "spell_failure", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "breastplate",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "proficiency", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "uint256", name: "armor_bonus", type: "uint256" },
          { internalType: "uint256", name: "max_dex_bonus", type: "uint256" },
          { internalType: "int256", name: "penalty", type: "int256" },
          { internalType: "uint256", name: "spell_failure", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "buckler",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "proficiency", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "uint256", name: "armor_bonus", type: "uint256" },
          { internalType: "uint256", name: "max_dex_bonus", type: "uint256" },
          { internalType: "int256", name: "penalty", type: "int256" },
          { internalType: "uint256", name: "spell_failure", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "chain_shirt",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "proficiency", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "uint256", name: "armor_bonus", type: "uint256" },
          { internalType: "uint256", name: "max_dex_bonus", type: "uint256" },
          { internalType: "int256", name: "penalty", type: "int256" },
          { internalType: "uint256", name: "spell_failure", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "chainmail",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "proficiency", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "uint256", name: "armor_bonus", type: "uint256" },
          { internalType: "uint256", name: "max_dex_bonus", type: "uint256" },
          { internalType: "int256", name: "penalty", type: "int256" },
          { internalType: "uint256", name: "spell_failure", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "class",
        outputs: [{ internalType: "string", name: "", type: "string" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "full_plate",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "proficiency", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "uint256", name: "armor_bonus", type: "uint256" },
          { internalType: "uint256", name: "max_dex_bonus", type: "uint256" },
          { internalType: "int256", name: "penalty", type: "int256" },
          { internalType: "uint256", name: "spell_failure", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [{ internalType: "uint256", name: "_id", type: "uint256" }],
        name: "get_proficiency_by_id",
        outputs: [
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "half_plate",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "proficiency", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "uint256", name: "armor_bonus", type: "uint256" },
          { internalType: "uint256", name: "max_dex_bonus", type: "uint256" },
          { internalType: "int256", name: "penalty", type: "int256" },
          { internalType: "uint256", name: "spell_failure", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "hide",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "proficiency", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "uint256", name: "armor_bonus", type: "uint256" },
          { internalType: "uint256", name: "max_dex_bonus", type: "uint256" },
          { internalType: "int256", name: "penalty", type: "int256" },
          { internalType: "uint256", name: "spell_failure", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "index",
        outputs: [{ internalType: "string", name: "", type: "string" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [{ internalType: "uint256", name: "_id", type: "uint256" }],
        name: "item_by_id",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "proficiency", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "uint256", name: "armor_bonus", type: "uint256" },
          { internalType: "uint256", name: "max_dex_bonus", type: "uint256" },
          { internalType: "int256", name: "penalty", type: "int256" },
          { internalType: "uint256", name: "spell_failure", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "leather",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "proficiency", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "uint256", name: "armor_bonus", type: "uint256" },
          { internalType: "uint256", name: "max_dex_bonus", type: "uint256" },
          { internalType: "int256", name: "penalty", type: "int256" },
          { internalType: "uint256", name: "spell_failure", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "padded",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "proficiency", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "uint256", name: "armor_bonus", type: "uint256" },
          { internalType: "uint256", name: "max_dex_bonus", type: "uint256" },
          { internalType: "int256", name: "penalty", type: "int256" },
          { internalType: "uint256", name: "spell_failure", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "scale_mail",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "proficiency", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "uint256", name: "armor_bonus", type: "uint256" },
          { internalType: "uint256", name: "max_dex_bonus", type: "uint256" },
          { internalType: "int256", name: "penalty", type: "int256" },
          { internalType: "uint256", name: "spell_failure", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "shield_heavy_steel",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "proficiency", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "uint256", name: "armor_bonus", type: "uint256" },
          { internalType: "uint256", name: "max_dex_bonus", type: "uint256" },
          { internalType: "int256", name: "penalty", type: "int256" },
          { internalType: "uint256", name: "spell_failure", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "shield_heavy_wooden",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "proficiency", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "uint256", name: "armor_bonus", type: "uint256" },
          { internalType: "uint256", name: "max_dex_bonus", type: "uint256" },
          { internalType: "int256", name: "penalty", type: "int256" },
          { internalType: "uint256", name: "spell_failure", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "shield_light_steel",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "proficiency", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "uint256", name: "armor_bonus", type: "uint256" },
          { internalType: "uint256", name: "max_dex_bonus", type: "uint256" },
          { internalType: "int256", name: "penalty", type: "int256" },
          { internalType: "uint256", name: "spell_failure", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "shield_light_wooden",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "proficiency", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "uint256", name: "armor_bonus", type: "uint256" },
          { internalType: "uint256", name: "max_dex_bonus", type: "uint256" },
          { internalType: "int256", name: "penalty", type: "int256" },
          { internalType: "uint256", name: "spell_failure", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "shield_tower",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "proficiency", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "uint256", name: "armor_bonus", type: "uint256" },
          { internalType: "uint256", name: "max_dex_bonus", type: "uint256" },
          { internalType: "int256", name: "penalty", type: "int256" },
          { internalType: "uint256", name: "spell_failure", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "splint_mail",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "proficiency", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "uint256", name: "armor_bonus", type: "uint256" },
          { internalType: "uint256", name: "max_dex_bonus", type: "uint256" },
          { internalType: "int256", name: "penalty", type: "int256" },
          { internalType: "uint256", name: "spell_failure", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "studded_leather",
        outputs: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "cost", type: "uint256" },
          { internalType: "uint256", name: "proficiency", type: "uint256" },
          { internalType: "uint256", name: "weight", type: "uint256" },
          { internalType: "uint256", name: "armor_bonus", type: "uint256" },
          { internalType: "uint256", name: "max_dex_bonus", type: "uint256" },
          { internalType: "int256", name: "penalty", type: "int256" },
          { internalType: "uint256", name: "spell_failure", type: "uint256" },
          { internalType: "string", name: "name", type: "string" },
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
    ],
  },
  WEAPONS: {
    ADDRESS: "0xeE1a2EA55945223404d73C0BbE57f540BBAAD0D8",
    ABI: [
      {
        inputs: [],
        name: "axe",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "axe_orc_double",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "battleaxe",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "chain_spiked",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "class",
        outputs: [{ internalType: "string", name: "", type: "string" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "club",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "crossbow_hand",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "crossbow_heavy",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "crossbow_light",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "crossbow_repeating_heavy",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "crossbow_repeating_light",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "dagger",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "dart",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "falchion",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "flail",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "flail_dire",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "flail_heavy",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "gauntlet",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "gauntlet_spiked",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [{ internalType: "uint256", name: "_id", type: "uint256" }],
        name: "get_damage_type_by_id",
        outputs: [
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [{ internalType: "uint256", name: "_id", type: "uint256" }],
        name: "get_encumbrance_by_id",
        outputs: [
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [{ internalType: "uint256", name: "_id", type: "uint256" }],
        name: "get_proficiency_by_id",
        outputs: [
          { internalType: "string", name: "description", type: "string" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "glaive",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "greataxe",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "greatclub",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "greatsword",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "guisarme",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "halberd",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "hammer_light",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "handaxe",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "index",
        outputs: [{ internalType: "string", name: "", type: "string" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [{ internalType: "uint256", name: "_id", type: "uint256" }],
        name: "item_by_id",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "javelin",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "kama",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "kukri",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "lance",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "longbow",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "longbow_composite",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "longspear",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "longsword",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "mace_heavy",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "mace_light",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "morningstar",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "nunchaku",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "pick_heavy",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "pick_light",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "quarterstaff",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "ranseur",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "rapier",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "sai",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "sap",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "scimitar",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "scythe",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "shortbow",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "shortbow_composite",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "shortspear",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "siangham",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "sickle",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "sling",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "spear",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "sword_bastard",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "sword_short",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "trident",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "waraxe_dwarven",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "warhammer",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              { internalType: "uint256", name: "cost", type: "uint256" },
              { internalType: "uint256", name: "proficiency", type: "uint256" },
              { internalType: "uint256", name: "encumbrance", type: "uint256" },
              { internalType: "uint256", name: "damage_type", type: "uint256" },
              { internalType: "uint256", name: "weight", type: "uint256" },
              { internalType: "uint256", name: "damage", type: "uint256" },
              { internalType: "uint256", name: "critical", type: "uint256" },
              {
                internalType: "int256",
                name: "critical_modifier",
                type: "int256",
              },
              {
                internalType: "uint256",
                name: "range_increment",
                type: "uint256",
              },
              { internalType: "string", name: "name", type: "string" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct codex.weapon",
            name: "_weapon",
            type: "tuple",
          },
        ],
        stateMutability: "pure",
        type: "function",
      },
    ],
  },
};

export {
  RARITY_ABI,
  RARITY_ADDRESS,
  RARITY_ABI_ATTRIBUTES,
  RARITY_ADDRESS_ATTRIBUTES,
  RARITY_ADDRESS_NAMES,
  RARITY_ABI_FOREST,
  RARITY_ADDRESS_FOREST,
  RARITY_ABI_NAMES,
  CODEX_ABI_SKILLS,
  CODEX_ADDRESS_SKILLS,
  RARITY_ADDRESS_SKILLS,
  RARITY_ABI_SKILLS,
  RARITY_ABI_DUNGEONS,
  RARITY_ADDRESS_GOLD,
  RARITY_ABI_GOLD,
  RARITY_ADDRESS_DUNGEONS,
  WEB3_FANTOM_INSTANCE,
  WEB3_LOCAL_INSTANCE,
  FANTOM_NETWORK,
  FANTOM_ID,
  RARITY_SUMMONERS,
  RARITY_BASE_MAX_SCORE,
  RARITY_ABI_FEATS,
  RARITY_ADDRESS_FEATS,
  CODEX_ABI_FEATS_1,
  CODEX_ABI_FEATS_2,
  CODEX_ADDRESS_FEATS_1,
  CODEX_ADDRESS_FEATS_2,
  RARITY_ABI_DAYCARE,
  RARITY_ADDRESS_DAYCARE,
  RARITY_CRAFT
};
